import $ from 'jquery';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext';
import { supabase } from '../lib/supabaseClient.ts';
import AdvancedSearch from './search/AdvancedSearch.js';


function Header() {
  const { cart, removeFromCart, updateQuantity } = useCart();
  const [mobileCartOpen, setMobileCartOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [rodentCategories, setRodentCategories] = useState([]);
  const [birdCategories, setBirdCategories] = useState([]);
  const [categories, setCategories] = useState([{ id: 0, name: "Chats" }]);
  const [dogcategories, setDogCategories] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);
useEffect(() => {
  const handleResize = () => setWindowWidth(window.innerWidth);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
  const handleSearchToggle = () => {
    setAdvancedSearchOpen(!advancedSearchOpen);
    setBurgerMenuOpen(false);
    setMobileCartOpen(false);
  };
  useEffect(() => {
    if (advancedSearchOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [advancedSearchOpen]);
  const handleBurgerMenuToggle = () => {
    setBurgerMenuOpen(!burgerMenuOpen);
    setSearchOpen(false);  // Close the search when burger menu is toggled
    setMobileCartOpen(false);  // Close the cart when burger menu is toggled
  };

  const handleCartToggle = () => {
    setMobileCartOpen(!mobileCartOpen);
    setSearchOpen(false);  // Close the search when cart is toggled
    setBurgerMenuOpen(false);  // Close the burger menu when cart is toggled
  };


  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "cat");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        // Desired order
        const order = ["Aliments Pour Chats", "Accessoires Pour Chats"];
        const sortedData = [...data].sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name);

          // If a category is not in order array, push it to the end
          const posA = indexA === -1 ? Number.MAX_VALUE : indexA;
          const posB = indexB === -1 ? Number.MAX_VALUE : indexB;

          return posA - posB;
        });

        setCategories(sortedData);
        if (sortedData.length > 0) {
          setSelectedCategory(sortedData[0].name); // Default category
        }
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchDogCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "dog");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        // Ordre souhaité
        const order = ["Aliments Pour Chiens", "Accessoires Pour Chiens"];
        const sortedData = [...data].sort((a, b) => {
          const indexA = order.indexOf(a.name);
          const indexB = order.indexOf(b.name);

          // Les catégories non listées vont à la fin
          const posA = indexA === -1 ? Number.MAX_VALUE : indexA;
          const posB = indexB === -1 ? Number.MAX_VALUE : indexB;

          return posA - posB;
        });

        setDogCategories(sortedData);
        if (sortedData.length > 0) {
          setSelectedCategory(sortedData[0].name); // catégorie par défaut
        }
      }
    };

    fetchDogCategories(); // appel de la fonction asynchrone
  }, []);

  // 🐭 Fetch Rodent categories
  useEffect(() => {
    const fetchRodentCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "rongeur");

      if (error) {
        console.error("Error fetching rodent categories:", error);
      } else {
        setRodentCategories(data);
      }
    };

    fetchRodentCategories();
  }, []);

  // 🐦 Fetch Bird categories
  useEffect(() => {
    const fetchBirdCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "oiseaux");

      if (error) {
        console.error("Error fetching bird categories:", error);
      } else {
        setBirdCategories(data);
      }
    };

    fetchBirdCategories();
  }, []);

  const getItemPrice = (item) => {
    // If the item has a selected variation with an oldPrice, use it; otherwise use selectedPrice
    if (item.selectedWeight || item.selectedGout) {
      return Number(item.oldPrice || item.selectedPrice || 0);
    }
    return Number(item.selectedPrice || 0);
  };

  // Format price for display
  const formatPrice = (price) => {
    if (price == null) return "0.000";
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    }).format(Number(price));
  };


  // Calculate total
  const total = cart.reduce((sum, item) => {
    const price = Number(item.selectedPrice) || 0;
    const qty = Number(item.quantity) || 1;
    return sum + price * qty;
  }, 0);

  const totalFormatted = formatPrice(total);

  // const totalFormatted = total.toFixed(2);

  const renderVariation = (item) => {
    if (!item.selectedGout && !item.selectedWeight) return null;

    return (
      <div
        style={{
          fontSize: "12px",
          color: "#777",
          marginTop: "2px",
          marginBottom: "4px",
        }}
      >
        {item.selectedGout && <span>Goût : {item.selectedGout}</span>}
        {item.selectedGout && item.selectedWeight && <span> • </span>}
        {item.selectedWeight && <span>Poids : {item.selectedWeight}</span>}
      </div>
    );
  };


  const handleActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    });
    e.target.parentNode.classList += ' active';
  };

  const subActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    });
    e.target.parentNode.parentNode.parentNode.classList += ' active';
  };

  useEffect(() => {
    // SubMenu Dropdown Toggle
    if ($('.menu-area li.menu-item-has-children ul').length) {
      $('.menu-area .navigation li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');
    }

    if ($('.mobile-menu').length) {
      var mobileMenuContent = $('.menu-area .main-menu').html();
$('.mobile-menu .menu-box .menu-outer').empty().append(mobileMenuContent);

      // Dropdown Button
      $('.mobile-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
        $(this).toggleClass('open');
        $(this).prev('ul').slideToggle(500);
      });

      // Menu Toggle Btn
      $('.mobile-nav-toggler').on('click', function () {
        $('body').addClass('mobile-menu-visible');
      });

      // Close mobile menu on backdrop or close button
      $('.menu-backdrop, .mobile-menu .close-btn').on('click', function () {
        $('body').removeClass('mobile-menu-visible');
      });

      // ✅ Close mobile menu after choosing an item
      $('.mobile-menu .menu-box .menu-outer a').on('click', function () {
        $('body').removeClass('mobile-menu-visible');
      });
    }

    $(".navbar-toggle").on('click', function () {
      $(".navbar-nav").addClass("mobile_menu");
    });

    $(".navbar-nav li a").on('click', function () {
      $(".navbar-collapse").removeClass("show");
    });

    $(".header-search > a").on('click', function () {
      $(".search-popup-wrap").slideToggle();
      return false;
    });

    $(".search-close").on('click', function () {
      $(".search-popup-wrap").slideUp(500);
    });
  }, []);


  return (
    <header>
      <div className="header-top-area">
        <div className="container custom-container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <div className="header-top-left">
                <ul>
                  <li>Appelez-nous:+216 90 117 027</li>
                  <li><i className="far fa-clock" />Horaire: 09:00 - 20:00 / 7j/7</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="header-top-right">
                <ul className="header-top-social">
                  <li className="follow">Follow :</li>
                  <li>
                    <a
                      href="https://www.facebook.com/animaliamutu/?locale=fr_FR"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/animaliaplus/?hl=fr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div id="sticky-header" className="menu-area">
        <div className="container custom-container">

          <div className="row">
            <div className="col-12">
{windowWidth < 768 && (
  <div style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "4px 16px",
    boxSizing: "border-box",
  }}>

    {/* LEFT: Logo */}
    <Link to="/" onClick={(e) => e.stopPropagation()} style={{ flexShrink: 0 }}>
      <img
        src="img/logo/animalia.png"
        alt="Animalia Logo"
        style={{ width: "140px", height: "100px", display: "block" ,marginLeft:"70px"}}
      />
    </Link>

    {/* RIGHT: icons — all vertically centered */}
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "18px",
      flexShrink: 0,
    }}>

      {/* ── Burger: renamed class to avoid jQuery conflict ── */}
      <div
        className="animalia-burger-btn"  
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // Directly toggle the theme's mobile menu via jQuery/body class
          document.body.classList.toggle('mobile-menu-visible');
        }}
        style={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "5px",
          width: "24px",
          height: "24px",
          flexShrink: 0,
        }}
      >
        <span style={{ display: "block", height: "2px", width: "22px", background: "#ff41b4", borderRadius: "2px" }} />
        <span style={{ display: "block", height: "2px", width: "15px", background: "#ff41b4", borderRadius: "2px" }} />
        <span style={{ display: "block", height: "2px", width: "22px", background: "#ff41b4", borderRadius: "2px" }} />
      </div>

      {/* ── Cart ── */}
      <div
        style={{ position: "relative", cursor: "pointer", display: "flex", alignItems: "center" }}
        onClick={(e) => { e.stopPropagation(); handleCartToggle(); }}
      >
        <i className="flaticon-shopping-bag" style={{ fontSize: "22px", color: "#ff41b4", lineHeight: 1 }} />
        {cart.length > 0 && (
          <span style={{
            position: "absolute",
            top: "-6px",
            right: "-8px",
            background: "#ff41b4",
            color: "#fff",
            fontSize: "10px",
            fontWeight: "bold",
            borderRadius: "50%",
            width: "17px",
            height: "17px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            {cart.length}
          </span>
        )}
      </div>

      {/* ── Search ── */}
      <div
        onClick={(e) => { e.stopPropagation(); handleSearchToggle(); }}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        <i className="fas fa-search" style={{ fontSize: "20px", color: "#ff41b4", lineHeight: 1 }} />
      </div>

    </div>
  </div>
)}
              {/* <div className="burger-search-wrap" style={{ display: "flex", alignItems: "center", gap: "10px" }}>



              </div> */}

              {/* Mobile Cart dropdown */}

              {mobileCartOpen && (
                <>
                  {/* Overlay */}
                  <div
                    onClick={() => setMobileCartOpen(false)}
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.35)",
                      backdropFilter: "blur(2px)",
                      zIndex: 999,
                      animation: "overlayIn 0.2s ease",
                    }}
                  />

                  {/* Panel */}
                  <div
                    style={{
                      position: "absolute",
                      top: "58px",
                      right: "10px",
                      width: "min(92vw, 340px)",
                      background: "#ffffff",
                      borderRadius: "20px",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.18), 0 4px 16px rgba(255,65,180,0.08)",
                      overflow: "hidden",
                      zIndex: 1001,
                      animation: "cartSlideIn 0.28s cubic-bezier(0.34, 1.56, 0.64, 1)",
                      fontFamily: "'DM Sans', sans-serif",
                      border: "1px solid rgba(255,65,180,0.1)",
                    }}
                  >
                    {/* ── Header ── */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "16px 18px 14px",
                        borderBottom: "1px solid #f3e8f5",
                        background: "linear-gradient(135deg, #fff 60%, #fff0fa)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: 700,
                          color: "#1a1a1a",
                          letterSpacing: "-0.3px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        🛍️ Mon Panier
                        {cart.length > 0 && (
                          <span
                            style={{
                              background: "linear-gradient(135deg, #ff41b4, #e03299)",
                              color: "white",
                              fontSize: "11px",
                              fontWeight: 700,
                              padding: "2px 7px",
                              borderRadius: "20px",
                              minWidth: "20px",
                              textAlign: "center",
                            }}
                          >
                            {cart.length}
                          </span>
                        )}
                      </div>

                      <button
                        onClick={() => setMobileCartOpen(false)}
                        style={{
                          background: "#f5f5f5",
                          border: "none",
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#888",
                          fontSize: "13px",
                          transition: "background 0.2s, color 0.2s",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = "#ffe0f4"; e.currentTarget.style.color = "#ff41b4"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = "#f5f5f5"; e.currentTarget.style.color = "#888"; }}
                      >
                        <i className="fas fa-times" />
                      </button>
                    </div>

                    {/* ── Items List ── */}
                    <div
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        padding: "10px 14px",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#f0c4e8 transparent",
                      }}
                    >
                      {cart.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "36px 20px" }}>
                          <div style={{ fontSize: "40px", marginBottom: "10px" }}>🛒</div>
                          <div style={{ fontSize: "14px", fontWeight: 500, color: "#999" }}>
                            Votre panier est vide
                          </div>
                        </div>
                      ) : (
                        cart.map((item, index) => (
                          <div
                            key={item.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              padding: "10px 6px",
                              borderBottom: index < cart.length - 1 ? "1px solid #faf0fb" : "none",
                              borderRadius: "10px",
                            }}
                          >
                            {/* ── Image + Quantity Stack ── */}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", flexShrink: 0 }}>

                              {/* Image */}
                              {item.image ? (
                                <img
                                  src={item.image}
                                  alt={item.name}
                                  onClick={() => {
                                    setMobileCartOpen(false);
                                    navigate(`/shop-details/${item.id}`);
                                    window.scrollBy({ top: 30, left: 0, behavior: "smooth" });
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                    e.currentTarget.nextSibling.style.display = "flex";
                                  }}
                                  style={{
                                    width: "54px",
                                    height: "54px",
                                    objectFit: "cover",
                                    borderRadius: "12px",
                                    border: "2px solid #f8eafc",
                                    cursor: "pointer",
                                    marginLeft: "100px"
                                  }}
                                />
                              ) : null}

                              {/* Fallback */}
                              <div
                                onClick={() => {
                                  setMobileCartOpen(false);
                                  navigate(`/shop-details/${item.id}`);
                                  window.scrollBy({ top: 30, left: 0, behavior: "smooth" });
                                }}
                                style={{
                                  display: item.image ? "none" : "flex",
                                  width: "54px",
                                  height: "54px",
                                  borderRadius: "12px",
                                  border: "2px solid #f8eafc",
                                  background: "linear-gradient(135deg, #fff0fa, #fde8f5)",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                              >
                                🐾
                              </div>

                              {/* ── Quantity Controls ── */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  background: "#f9f0fd",
                                  borderRadius: "20px",
                                  border: "1px solid #f0d6f5",
                                  overflow: "hidden",
                                  height: "26px",
                                  width: "70px",
                                  marginRight: "100px"
                                }}
                              >
                                {/* Decrease */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (item.quantity > 1) {
                                      updateQuantity(item.id, item.quantity - 1);
                                    } else {
                                      removeFromCart(item.id);
                                    }
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    width: "24px",
                                    height: "26px",
                                    cursor: "pointer",
                                    color: "#ff41b4",
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    lineHeight: 1,
                                    flexShrink: 0,
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.background = "#fce4f6"}
                                  onMouseLeave={(e) => e.currentTarget.style.background = "none"}
                                >
                                  −
                                </button>

                                {/* Count */}
                                <span
                                  style={{
                                    flex: 1,
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    color: "#1a1a1a",
                                    textAlign: "center",
                                  }}
                                >
                                  {item.quantity}
                                </span>

                                {/* Increase */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    updateQuantity(item.id, item.quantity + 1);
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    width: "24px",
                                    height: "26px",
                                    cursor: "pointer",
                                    color: "#ff41b4",
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    lineHeight: 1,
                                    flexShrink: 0,
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.background = "#fce4f6"}
                                  onMouseLeave={(e) => e.currentTarget.style.background = "none"}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* ── Info ── */}
                            <div
                              style={{ flex: 1, minWidth: 0, cursor: "pointer", marginLeft: "-80px" }}
                              onClick={() => {
                                setMobileCartOpen(false);
                                navigate(`/shop-details/${item.id}`);
                                window.scrollBy({ top: 30, left: 0, behavior: "smooth" });
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#222",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  marginBottom: "3px",
                                }}
                              >
                                {item.name}
                              </div>

                              {renderVariation(item) && (
                                <div style={{ fontSize: "11px", color: "#aaa", marginBottom: "4px" }}>
                                  {renderVariation(item)}
                                </div>
                              )}

                              {/* Subtotal for this item */}
                              <div style={{ fontSize: "13px", fontWeight: 700, color: "#ff41b4" }}>
                                {new Intl.NumberFormat("fr-FR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(item.selectedPrice * item.quantity)}{" "}DT
                              </div>

                              {/* Unit price hint */}
                              <div style={{ fontSize: "11px", color: "#bbb", marginTop: "2px" }}>
                                {new Intl.NumberFormat("fr-FR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(item.selectedPrice)} DT / unité
                              </div>
                            </div>

                            {/* ── Remove ── */}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFromCart(item.id);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "8px",
                                cursor: "pointer",
                                color: "#ddd",
                                fontSize: "13px",
                                flexShrink: 0,
                                alignSelf: "flex-start",
                                marginTop: "2px",
                              }}
                              onMouseEnter={(e) => { e.currentTarget.style.color = "#e03299"; e.currentTarget.style.background = "#ffe0f4"; }}
                              onMouseLeave={(e) => { e.currentTarget.style.color = "#ddd"; e.currentTarget.style.background = "none"; }}
                            >
                              <i className="far fa-trash-alt" />
                            </button>
                          </div>
                        ))
                      )}
                    </div>

                    {/* ── Footer ── */}
                    {cart.length > 0 && (
                      <div
                        style={{
                          padding: "12px 16px 16px",
                          background: "linear-gradient(180deg, #fff 0%, #fdf5ff 100%)",
                          borderTop: "1px solid #f3e8f5",
                        }}
                      >
                        {/* Total */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "12px",
                          }}
                        >
                          <span style={{ fontSize: "13px", color: "#888", fontWeight: 500 }}>Total</span>
                          <span style={{ fontSize: "18px", fontWeight: 800, color: "#1a1a1a", letterSpacing: "-0.5px" }}>
                            {new Intl.NumberFormat("fr-FR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(
                              cart.reduce((acc, item) => acc + item.selectedPrice * item.quantity, 0)
                            )}{" "}DT
                          </span>
                        </div>

                        {/* Buttons */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                          <Link
                            to="/cart"
                            onClick={() => setMobileCartOpen(false)}
                            style={{
                              padding: "11px 8px",
                              borderRadius: "50px",
                              textDecoration: "none",
                              fontSize: "13px",
                              fontWeight: 700,
                              textAlign: "center",
                              background: "transparent",
                              color: "#ff41b4",
                              border: "2px solid #ff41b4",
                              transition: "background 0.2s, box-shadow 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#fff0fa";
                              e.currentTarget.style.boxShadow = "0 2px 12px rgba(255,65,180,0.15)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            Panier
                          </Link>

                          <Link
                            to="/checkout"
                            onClick={() => setMobileCartOpen(false)}
                            style={{
                              padding: "11px 8px",
                              borderRadius: "50px",
                              textDecoration: "none",
                              fontSize: "13px",
                              fontWeight: 700,
                              textAlign: "center",
                              background: "linear-gradient(135deg, #ff41b4, #e03299)",
                              color: "#fff",
                              border: "none",
                              boxShadow: "0 4px 14px rgba(255,65,180,0.35)",
                              transition: "box-shadow 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.boxShadow = "0 6px 20px rgba(255,65,180,0.45)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.boxShadow = "0 4px 14px rgba(255,65,180,0.35)";
                            }}
                          >
                            Paiement →
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}


              <Link to="/" style={{ display: "inline-block" }}>

                <div className="menu-wrap">
                  <nav className="menu-nav show">
<div className="logo d-none d-lg-block" style={{ display: "inline-block" }}>
                      <img
                        src="img/logo/animalia.png"
                        alt="Animalia Logo"
                        title="Animalia"
                        style={{
                          width: window.innerWidth > 768 ? "350px" : "300px",
                          height: window.innerWidth > 768 ? "50px" : "auto",
                          marginLeft: window.innerWidth > 768 ? "-160px" : "-80px", // web: -160px, mobile: 0
                        }}
                      />
                    </div>


                    <div
                      className="navbar-wrap main-menu d-none d-lg-flex justify-end pr-2 ms-0 "
                      style={{ minWidth: "920px" }} >
                      <ul className="navigation flex  text-xs items-center ">
                        <li className="active menu-item-has-children">
                          <Link to="/" onClick={handleActive}>Acceuil</Link>
                        </li>
                        <li className="has-submenu">
                          <Link to="/catlist" onClick={handleActive}>Chats</Link>
                          <ul className="submenu">
                            {categories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>
                                  {cat.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>


                        <li className="has-submenu">
                          <Link to="/doglist" onClick={handleActive}>Chiens</Link>
                          <ul className="submenu">
                            {dogcategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>{cat.name}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                        {/* Rongeurs */}
                        <li className="has-submenu">
                          <Link to="/rongeurlist" onClick={handleActive}>Rongeurs</Link>
                          <ul className="submenu">
                            {rodentCategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>
                                  {cat.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>

                        {/* Oiseaux */}
                        <li className="has-submenu">
                          <Link to="/birdlist" onClick={handleActive}>Oiseaux</Link>
                          <ul className="submenu">
                            {birdCategories.map((cat, index) => (
                              <li key={index}>
                                <Link to={`/category/${cat.id}/${encodeURIComponent(cat.name)}`} onClick={subActive}>
                                  {cat.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="menu-item-has-children">
                          <Link to="/shop" onClick={handleActive}>Shop</Link>
                        </li>
                        <li className="menu-item-has-children">
                          <Link to="/categories" onClick={handleActive}>Catégories</Link>
                        </li>

                        <li className="menu-item-has-children">
                          <Link to="/bons" onClick={handleActive}>Bon plan</Link>
                        </li>
                        <li>
                          <Link to="/contacts" onClick={handleActive}>Contact</Link>
                        </li>
                      </ul>
                    </div>



                    {/* Desktop Cart */}
                    <div className="header-action d-none d-md-block">
                      <ul>
                        {/* <li className="header-search">
                        <a href="/#"><i className="flaticon-search" /></a>
                      </li> */}


                        <li className="header-shop-cart">
                          <a
                            href="/#"
                            className="cart-icon-wrapper"
                            style={{ position: "relative", display: "inline-block" }}
                          >
                            <i className="flaticon-shopping-bag" style={{ fontSize: "20px", marginLeft: "40px" }} />
                            {cart.length > 0 && (
                              <span className='cart-sign'
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "50px",
                                  background: "#ff41b4",
                                  color: "#fff",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  borderRadius: "50%",
                                  width: "18px",
                                  height: "18px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                }}
                              >
                                {cart.length}
                              </span>
                            )}
                          </a>


                          <ul
                            className="minicart"
                            style={{
                              width: "420px",   // control minicart width here
                              maxHeight: "70vh",
                              overflowY: "auto",
                              padding: "12px",
                            }}
                          >
                            {cart.map((item, index) => {
                              const price = Number(item.selectedPrice) || 0;
                              const qty = Number(item.quantity) || 1;

                              return (
                                <li
                                  key={item.id}
                                  className="d-flex align-items-center"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "8px 0",
                                    borderBottom: "1px solid #eee",
                                    marginLeft: index === 0 ? "10px" : "0", // 👈 Add margin only for first item
                                  }}
                                  onClick={() => navigate(`/shop-details/${item.id}`)} // navigate on click

                                >

                                  {/* Product Image */}
                                  <div
                                    className="cart-img"
                                    style={{ flexShrink: 0, marginRight: "-5px", width: "400px" }}
                                  >
                                    <Link to={`/shop-details/${item.id}`}>
                                      <img
                                        src={item.image}
                                        alt={item.name}
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                          borderRadius: "6px",
                                        }}
                                      />
                                    </Link>
                                  </div>

                                  {/* Product Content */}
                                  {/* Product Content */}
                                  <div
                                    className="cart-content"
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <h4 style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
                                      <Link to={`/shop-details/${item.id}`}>{item.name}</Link>
                                      {renderVariation(item)}
                                    </h4>
                                    <div
                                      className="cart-price d-flex align-items-center"
                                      style={{ fontSize: "13px", marginBottom: "6px" }}
                                    >
                                      <span className="new">
                                        {getItemPrice(item).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT x {item.quantity}
                                      </span>
                                      <span
                                        className="total-price"
                                        style={{ fontWeight: "bold", marginLeft: "10px", marginTop: "-20px" }}
                                      >
                                        = {(getItemPrice(item) * item.quantity).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} DT
                                      </span>
                                    </div>


                                    {/* Quantity Controls */}
                                    <div className="d-flex align-items-center">
                                      <button
                                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                        disabled={item.quantity <= 1}
                                        style={{
                                          width: "26px",
                                          height: "26px",
                                          borderRadius: "50%",
                                          border: "none",
                                          background: "#ff41b4",
                                          color: "#fff",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          cursor: item.quantity <= 1 ? "not-allowed" : "pointer",
                                          opacity: item.quantity <= 1 ? 0.5 : 1,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        -
                                      </button>
                                      <span
                                        style={{
                                          minWidth: "25px",
                                          textAlign: "center",
                                          margin: "0 6px",
                                          color: "gray",
                                        }}
                                      >
                                        {item.quantity}
                                      </span>
                                      <button
                                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                        style={{
                                          width: "26px",
                                          height: "26px",
                                          borderRadius: "50%",
                                          border: "none",
                                          background: "#ff41b4",
                                          color: "#fff",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>

                                  {/* Delete Button */}
                                  <div
                                    className="del-icon"
                                    style={{
                                      flexShrink: 0,
                                      marginLeft: "10px",
                                    }}
                                  >
                                    <button
                                      onClick={() => removeFromCart(item.id)}
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        border: "none",
                                        background: "#ffe5eb",
                                        color: "#c00",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <i className="far fa-trash-alt" style={{ fontSize: "14px" }} />
                                    </button>
                                  </div>
                                </li>
                              );
                            })}

                            {cart.length > 0 ? (
                              <>
                                <li>
                                  <div className="total-price" style={{ fontWeight: "bold", color: "gray" }}>
                                    Total: {totalFormatted} DT
                                  </div>
                                </li>
                                <li>
                                  <div className="checkout-link d-flex justify-content-between">
                                    <Link to="/cart">Panier</Link>
                                    <Link to="/checkout" className="black-color">
                                      Paiement
                                    </Link>
                                  </div>
                                </li>
                              </>
                            ) : (
                              <li className="text-center p-3">Votre panier est vide 🛒</li>
                            )}
                          </ul>


                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </Link>

              {/* Mobile Menu */}
              <div className="mobile-menu">

                <nav className="menu-box" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                  <div className="close-btn"><i className="fas fa-times" /></div>
                  <div className="nav-logo">
                    <Link to="/"><img src="img/logo/animalia.png" alt="" title='true' /></Link>
                  </div>
                  <div className="menu-outer"></div>
                  {/* MOBILE CART */}

                  {/* Mobile Social Links */}
                  <div className="social-links">
                    Follow:
                    <ul className="clearfix">
                      {/* <li><a href="/#"><span className="fab fa-twitter" /></a></li> */}
                      <li><a href="/#"><span className="fab fa-facebook-square" /></a></li>
                      {/* <li><a href="/#"><span className="fab fa-pinterest-p" /></a></li> */}
                      <li><a href="/#"><span className="fab fa-instagram" /></a></li>
                      {/* <li><a href="/#"><span className="fab fa-youtube" /></a></li> */}
                    </ul>
                  </div>



                </nav>
              </div>

              <div className="menu-backdrop" />
            </div>
            {/* Search Icon/Button - Opens Advanced Search */}
            {windowWidth  >= 992 && (
              <div
                onClick={handleSearchToggle}
                style={{
                  position: 'relative',
                  marginTop: '20px',       // espace au-dessus
                  marginBottom: '20px',    // espace sous le bouton
                  marginLeft: 'auto',      // centre horizontalement
                  marginRight: 'auto',     // centre horizontalement
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center', // texte centré dans le bouton
                  gap: '10px',
                  width: '900px',          // largeur fixe
                  padding: '10px 20px',    // padding vertical et horizontal
                  border: '2px solid #ff41b4',
                  borderRadius: '25px',
                  background: 'white',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#fff5fb';
                  e.currentTarget.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <i className="fas fa-search" style={{ color: '#ff41b4', fontSize: '16px', marginLeft: '40px' }} />
                <span style={{ color: '#ff41b4', fontWeight: '600', fontSize: '14px' }}>
                </span>
                Chercher un article ...  </div>
            )}




          </div>
        </div>
        {/* <div className="header-shape" style={{ backgroundImage: "url('img/bg/header_shape.png')" }} /> */}
      </div>

      <div className="search-popup-wrap" tabIndex={-1} role="dialog" aria-hidden="true">
        <div className="search-close">
          <span><i className="fas fa-times" /></span>
        </div>
        <div className="search-wrap text-center">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="title">... Search Here ...</h2>
                <div className="search-form">
                  <form>
                    <input type="text" name="search" placeholder="Type keywords here" />
                    <button className="search-btn"><i className="fas fa-search" /></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdvancedSearch
        isOpen={advancedSearchOpen}
        onClose={() => setAdvancedSearchOpen(false)}
      />
      <style>{`
       /* Mobile menu bold items */
  .mobile-menu .menu-box .menu-outer ul li a {
    font-weight: 700 !important;
    font-size: 15px !important;
    color: #1a1a1a !important;
    letter-spacing: 0.2px;
  }

  .mobile-menu .menu-box .menu-outer ul li a:hover {
    color: #ff41b4 !important;
  }

  /* Remove duplicate dropdown arrows if they appear twice */
  .mobile-menu .menu-box .menu-outer .dropdown-btn + .dropdown-btn {
    display: none;
  }
    @keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes cartSlideIn {
      from { opacity: 0; transform: translateY(-12px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    .cart-item-row:hover { background: #fdf5ff !important; padding-left: 14px !important; }
    .cart-remove-btn:hover { color: #e03299 !important; background: #ffe0f4 !important; }
    .cart-close-btn:hover { background: #ffe0f4 !important; color: #ff41b4 !important; }
    .cart-items-list::-webkit-scrollbar { width: 4px; }
    .cart-items-list::-webkit-scrollbar-thumb { background: #f0c4e8; border-radius: 4px; }
  `}</style>
    </header>
  );
}

export default Header;
